import { DuplicateSelectionsMap } from '@amzn/awscat-portfolio-assessment-types';

import { DUPLICATE_SELECT_OPTION } from '../common-util/resources';
import { DuplicateRecordsMap } from '../common-util/types';

/**
 * Set selectedIndex for all IDs in duplicateSelectionsMap when user selects a quick option
 * @param duplicateSelectionsMap
 * @param duplicateRecordsMap
 * @param option
 */
export function setDuplicateSelections(duplicateSelectionsMap: DuplicateSelectionsMap,
    duplicateRecordsMap: DuplicateRecordsMap,
    option: DUPLICATE_SELECT_OPTION): void {
    if (option === DUPLICATE_SELECT_OPTION.MANUAL) {
        return;
    }
    Object.keys(duplicateRecordsMap).forEach(id => {
        let selectedIndex = duplicateSelectionsMap[id];
        if (option === DUPLICATE_SELECT_OPTION.FIRST) {
            selectedIndex = 0;
        } else if (option === DUPLICATE_SELECT_OPTION.LAST) {
            selectedIndex = duplicateRecordsMap[id]?.records?.length - 1;
        }
        setDuplicateSelectionForId(duplicateSelectionsMap, id, selectedIndex);
    });
}

/**
 * Set selectedIndex for a specific ID in duplicateSelectionsMap
 * @param duplicateSelectionsMap
 * @param id
 * @param selectedIndex
 */
export function setDuplicateSelectionForId(duplicateSelectionsMap: DuplicateSelectionsMap,
    id: string,
    selectedIndex: number): void {
    duplicateSelectionsMap[id] = selectedIndex;
}

/**
 * Count IDs for which the current selectedIndex will be overwritten by the quick select
 * @param duplicateSelectionsMap
 * @param duplicateRecordsMap
 * @param option
 */
export function getDupQuickSelectOverwriteCount(duplicateSelectionsMap:
    DuplicateSelectionsMap,                     duplicateRecordsMap: DuplicateRecordsMap,
option: DUPLICATE_SELECT_OPTION): number {
    let count = 0;
    if (option === DUPLICATE_SELECT_OPTION.MANUAL) {
        return count;
    }
    Object.keys(duplicateSelectionsMap).forEach(id => {
        const selectedIndex = duplicateSelectionsMap[id];
        if (selectedIndex == null) {
            return;
        } else if (option === DUPLICATE_SELECT_OPTION.FIRST) {
            count += (selectedIndex !== 0 ? 1 : 0);
        } else if (option === DUPLICATE_SELECT_OPTION.LAST) {
            count += (selectedIndex !== (duplicateRecordsMap[id]?.records?.length - 1) ? 1 : 0);
        }
    });
    return count;
}
